module.exports = __webpack_public_path__ + "fonts/materialdesignicons-webfont.20b6ebf3.woff";